<template>
  <div class="reset-password">
    <v-container class="pa-3 pt-5">
      <template v-if="!confirm">
        <v-form class="px-3" ref="passwordForm">
          <!-- 新しいパスワード -->
          <v-text-field
            v-model="newPassword"
            prepend-icon="mdi-lock"
            :rules="[rules.required, rules.password]"
            type="password"
            label="新しいパスワード"
            counter
          ></v-text-field>
          <!-- 新しいパスワード（確認） -->
          <v-text-field
            v-model="confirmPassword"
            prepend-icon="mdi-lock"
            :rules="[rules.required, rules.password]"
            type="password"
            label="新しいパスワード（確認）"
            counter
          ></v-text-field>
        </v-form>
        <div>
          {{ passwordErrorMessage }}
        </div>
        <v-btn text color="primary" :loading="loading" @click="submit">
          パスワードをリセットする
        </v-btn>
      </template>
      <div v-else>
        <p class="my-3 text-body-2">パスワード変更が完了しました。</p>
        <p class="my-3 text-body-2">トップに戻ってログインしてください。</p>
        <v-btn @click="gotoTopClick">
          トップに戻る
        </v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import * as authApi from '../api/modules/auth';
import { isSuccessStatus } from '../utils/http';

export default {
  data: () => ({
    confirm: false,
    loading: false,
    tm: null,
    newPassword: '',
    confirmPassword: '',
    rules: {
      required: value => !!value || '必須入力です',
      password: value => {
        const pattern = /^(?=.*?[a-z])(?=.*?\d)[a-z\d]{6,100}$/i;
        return (
          pattern.test(value) ||
          '半角英数字をそれぞれ1種類以上含んだ6文字以上で入力してください'
        );
      },
    },
    passwordErrorMessage: null,
  }),
  computed: {},
  methods: {
    async submit() {
      if (!this.$refs.passwordForm.validate()) {
        return;
      }
      if (this.newPassword != this.confirmPassword) {
        this.passwordErrorMessage = '新しいパスワードが一致しません。';
        return;
      }

      this.loading = true;
      const result = await authApi.verifyPasswordReset(
        this.$route.params.token,
        this.confirmPassword,
      );

      if (isSuccessStatus(result.statusCode)) {
        this.confirm = true;
        this.tm = setTimeout(() => {
          this.$store.dispatch('error/clearError');
          window.location = '/';
        }, 10000);
      } else {
        this.$store.dispatch(
          'error/setError',
          {
            code: result.statusCode,
            id: result.requestId,
            message: result.response,
          },
          { root: true },
        );
      }
      this.loading = false;
    },
    gotoTopClick() {
      if (this.tm) {
        clearInterval(this.tm);
      }
      this.$store.dispatch('error/clearError');
      window.location = '/';
    },
  },
  async created() {},
};
</script>
